import { useStore } from 'vuex'
import { computed, reactive } from 'vue'
import { useReseller } from '@/stores/reseller'
import ChatmixData from '@/assets/js/dash/ChatmixData'

export const maintainerData = computed(() => {
    const envData = import.meta.env
    const reseller = useStore()?.state?.reseller?.reseller ?? null
    const resellerStore = useReseller()

    //console.log(reseller, 'reseller')
    return {
        name: reseller?.name || resellerStore.data?.name || envData.VITE_CHAT_NAME,
        description: reseller?.description || resellerStore.data?.description || envData.VITE_CHAT_DESCRIPTION,
        logo_small: reseller?.logo_chat || resellerStore.data?.logo_chat || ChatmixData.logo.compact,
        logo_large: reseller?.logo_site || resellerStore.data?.logo_site || ChatmixData.logo.full,
        logo_dark: reseller?.logo_site || reseller?.logo_dark || resellerStore.data?.logo_dark || ChatmixData.logo.dark,
        support_phone: reseller?.support_phone || resellerStore.data?.supprt_phone || envData.VITE_CHAT_SUPPORT_PHONE,
        support_email: reseller?.support_email || resellerStore.data?.support_email || envData.VITE_CHAT_SUPPORT_EMAIL,
        color_primary: reseller?.color_primary || resellerStore.data?.color_primary || envData.VITE_CHAT_COLOR_PRIMARY,
        color_shadow: reseller?.color_shadow || resellerStore.data?.color_shadow || envData.VITE_CHAT_COLOR_SHADOW,
        dialog360_partner: reseller?.dialog360_partner || resellerStore.data?.dialog360_partner || envData.VITE_CHAT_DIALOG360_PARTNER,
    }
})

export const setLayoutDefault = () => {
        const data = maintainerData.value

        // Define layout primary color
        document.body.style.setProperty('--chatPrimary', data.color_primary)
        document.body.style.setProperty('--chatShadow', data.color_shadow)
        document.querySelector('link[rel*=\'icon\']').href = data.logo_small
}

export const authHeaderInfors = reactive({
    title: 'Login',
    subtitle: 'Entre com sua conta',
})

export const setHeaderInfors = (title, subtitle) => {
    authHeaderInfors.title = title
    authHeaderInfors.subtitle = subtitle
}
